import Base from './components/cells/Base';
import Icon from './components/cells/Icon';

export default function IconCell() {}

IconCell.prototype.init = function (params) {
    this.eGui = Base(Icon(params), params);
    return;
};

IconCell.prototype.getGui = function () {
    return this.eGui;
};
